module.exports = __webpack_public_path__ + "img/high_vis.74bee87b.png";